import React, { useState, useEffect } from "react";
import { getUserData } from "../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { CheckGeoConfigAccess } from "../services/GeoLocationApi";
import PickupDeliveryViewMap from "./PickupDeliveryViewMap";
import { postStoreRiderJobPickupOrDelivery } from "../services/StoreRiderInfo/StoreRiderInfo";
import { localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
 
const isValidCoordinate = (lat, lng) => {
  const latitude = Number(lat);
  const longitude = Number(lng);

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude < -90 ||
    latitude > 90 ||
    longitude < -180 ||
    longitude > 180
  ) {
    return false;
  }

  if (latitude === 0 && longitude === 0) {
    return false;
  }

  return true;
};

export default function PickupDeliveryMap() {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();
  
  let brandCode = brandProfileData.brandCode;

    const { storeData } = getUserData();
  
    const storeId = storeData.id;

  const [viewMap, setViewMap] = useState(false);
  const [resAPIKey, setResAPIKey] = useState("");
  const [noLocations, setNoLocations] = useState(false);
  const [loadingLocations, setLoadingLocations] = useState(true);

  let initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 15 days from current date
  
    const [startDate, setStartDate] = useState(new Date(initialStartDate));
  
    let initialEndDate = new Date();
    const [endDate, setEndDate] = useState(new Date(initialEndDate));

     const [pickupData, setPickupData] = useState([]);
  const [deliveryData, setDeliveryData] = useState([]);


  const fetchRiderJobPickupData = async (data) => {
    return postStoreRiderJobPickupOrDelivery(storeId, "pickup", data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const newRes = Res.slice(-25)
              .map((item) => {
                const address = item?.pickupRequest?.addressDTO;
  
                return {
                  type: "pickup",
                  customerName: item?.pickupRequest?.customerName,
                  customerMobile: item?.pickupRequest?.customerMobile,
                  timeSlot: item?.pickupRequest?.pickupTimeSlot,
                  lat: Number(address?.latitude),
                  lng: Number(address?.longitude),
                };
              })
              // FIX: object has `lat`/`lng`, not `latitude`/`longitude`
              .filter((item) => isValidCoordinate(item.lat, item.lng));
            return newRes;
          }
          return [];
        })
        .catch((err) => {
          console.error("Rider Job Error:", err);
          return [];
        });
    };
  
    const fetchRiderJobDeliveryData = async (data) => {
      return postStoreRiderJobPickupOrDelivery(storeId, "delivery", data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const newRes = Res.slice(-25)
              .map((item) => {
                const address = item?.deliveryRequest?.addressDTO;
  
                return {
                  type: "delivery",
                  customerName: item?.deliveryRequest?.order?.customerName,
                  customerMobile: item?.deliveryRequest?.order?.customerMobile,
                  timeSlot: item?.deliveryRequest?.deliveryTimeSlot,
                  lat: Number(address?.latitude),
                  lng: Number(address?.longitude),
                };
              })
              // FIX: same lat/lng vs latitude/longitude mismatch
              .filter((item) => isValidCoordinate(item.lat, item.lng));
            return newRes;
          }
          return [];
        })
        .catch((err) => {
          console.error("Rider Job Error:", err);
          return [];
        });
    };
  
  useEffect(() => {
    let isCurrentRequest = true;
    setLoadingLocations(true);
    setNoLocations(false);
    setViewMap(false);
      
      const pickupPayload = {
        startDate: localeDateStartDate(new Date(startDate)),
        endDate: localeDateEndDate(new Date(endDate)),
        jobStatus: [
          "PICKUP_REQ",
          "ASSIGNED_TO_RIDER",
          "RESCHEDULE_BY_CUSTOMER",
          "RESCHEDULE_BY_RIDER",
        ],
      };
  
      const deliveryPayload = {
        startDate: localeDateStartDate(new Date(startDate)),
        endDate: localeDateEndDate(new Date(endDate)),
        jobStatus: [
          "DELIVERY_REQ",
          "ASSIGNED_TO_RIDER",
          "RESCHEDULE_BY_CUSTOMER",
          "RESCHEDULE_BY_RIDER",
          "OUT_FOR_DELIVERY",
        ],
      };
  
      Promise.all([
        fetchRiderJobPickupData(pickupPayload),
        fetchRiderJobDeliveryData(deliveryPayload),
      ]).then(([newPickupData, newDeliveryData]) => {
        if (!isCurrentRequest) return;

        setPickupData(newPickupData);
        setDeliveryData(newDeliveryData);

        if (newPickupData.length === 0 && newDeliveryData.length === 0) {
          setNoLocations(true);
          setLoadingLocations(false);
          return;
        }

        const accessCount =
          newPickupData.length > 0 && newDeliveryData.length > 0 ? 2 : 1;

        CheckGeoConfigAccess({ brandCode, accessCount })
          .then((response) => {
            if (!isCurrentRequest) return;

            const { status, apiKey } = response.data;
            if (status === "success") {
              setViewMap(true);
              setResAPIKey(apiKey);
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          })
          .finally(() => {
            if (isCurrentRequest) setLoadingLocations(false);
          });
      });

      return () => {
        isCurrentRequest = false;
      };

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <>
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate(-1)}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Rider Route
              </p>
            </div>
          </div>
        </div>
      </div>
      {loadingLocations ? (
        <div className="flex justify-content-center mt-5">
          <p className="text-2xl font-bold">Loading rider locations...</p>
        </div>
      ) : noLocations ? (
        <div className="flex justify-content-center mt-5">
          <p className="text-2xl font-bold">
            No pickup or delivery locations found.
          </p>
        </div>
      ) : viewMap ? (
        <PickupDeliveryViewMap resAPIKey={resAPIKey} pickupData={pickupData} deliveryData={deliveryData} />
      ) : (
        <div className="flex justify-content-center mt-5">
          <p className="text-3xl font-bold capitalize">
            Your Account is Low Balance, Please Recharge Geo Location Account
            For Further Usage.
          </p>
        </div>
      )}
    </>
  );
}
